import React from 'react';
import { Box } from '@mui/material';
import { TicketSeverity } from '@marageti/z4-sdk/lib/tickets';

type TicketSeverityIconProps = {
  severity: TicketSeverity;
  /** Controls the inner bars area; container scales around it. Default 14. */
  size?: number;
};

const SEVERITY_LEVEL: Record<TicketSeverity, number> = {
  NO_ISSUE: 0,
  MINOR: 1,
  MAJOR: 2,
  CRITICAL: 3,
};

const getBarColor = (severity: TicketSeverity): string => (
  severity === 'CRITICAL' ? 'error.main' : 'text.primary'
);

const getBgColor = (severity: TicketSeverity): string => (
  severity === 'CRITICAL' ? 'error.light' : 'grey.200'
);

const INACTIVE_COLOR = 'grey.400';

const BAR_HEIGHT_RATIOS = [0.36, 0.71, 1];

const TicketSeverityIcon = ({ severity, size = 14 }: TicketSeverityIconProps) => {
  const level = SEVERITY_LEVEL[severity];
  const activeColor = getBarColor(severity);

  const barWidth = size * 0.25;
  const barRadius = barWidth / 2;
  const gap = size * 0.12;
  const px = size * 0.57;
  const py = size * 0.29;

  return (
    <Box
      sx={{
        width: size + px * 2,
        height: size + py * 2,
        borderRadius: `${size * 4}px`,
        bgcolor: getBgColor(severity),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          gap: `${gap}px`,
        }}
      >
        {BAR_HEIGHT_RATIOS.map((heightRatio, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            sx={{
              width: barWidth,
              height: `${heightRatio * size}px`,
              borderRadius: `${barRadius}px`,
              bgcolor: i < level ? activeColor : INACTIVE_COLOR,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TicketSeverityIcon;
